module.exports = __webpack_public_path__ + "static/media/feature1.33ed817a.jpg";